/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
import { useState } from "react";
import { Box, Button, Dialog, DialogTitle, DialogContent, DialogContentText, DialogActions } from "@mui/material";
import { SubmitButton, Overlay } from "@components";
import type { SxProps } from "@mui/material";

export const ConfirmButton = ({
  sx,
  onConfirm,
  dialogTitle,
  dialogText,
  dialogContent,
  children,
  forceOpen,
  onClose,
}: {
  sx?: SxProps;
  onConfirm: any;
  dialogTitle: string;
  dialogText?: string | JSX.Element;
  dialogContent?: JSX.Element;
  children: JSX.Element;
  forceOpen?: boolean;
  onClose?: () => void;
}) => {
  const [open, setOpen] = useState(false);
  const [isProcessing, setIsProcessing] = useState(false);
  const [abortController, setAbortController] = useState<AbortController | null>(null);

  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleClose = async () => {
    if (onClose) {
      await onClose();
    }

    if (abortController) {
      abortController.abort({ reason: "Operation cancelled by the user" });
      setAbortController(null);
    }

    setOpen(false);
  };

  const handleConfirm = async () => {
    try {
      await onConfirm();
    } catch (error) {
      console.error(error);
    } finally {
      setOpen(false);
      setIsProcessing(false);
    }
  };

  return (
    <Box sx={sx}>
      <Overlay isVisible={isProcessing} />

      <span onClick={handleClickOpen}>{children}</span>

      <Dialog
        open={open || !!forceOpen}
        onClose={handleClose}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="alert-dialog-title">{dialogTitle}</DialogTitle>
        <DialogContent>
          {dialogText ? <DialogContentText id="alert-dialog-description">{dialogText}</DialogContentText> : null}
          {dialogContent}
        </DialogContent>
        <DialogActions>
          <Button onClick={handleClose} disabled={isProcessing}>
            Cancel
          </Button>
          <SubmitButton isProcessing={isProcessing} color="primary" onClick={handleConfirm}>
            Confirm
          </SubmitButton>
        </DialogActions>
      </Dialog>
    </Box>
  );
};
